import { createPuzzleLevelStore } from "../modules/puzzle-level-store"
import { getPuzzleById } from "./puzzle-loader"

export const sortaballs8ColorsLevelStore = createPuzzleLevelStore({
  fallbackId: 1,
  isValid: id=> getPuzzleById(id) !== undefined,
  storageKey: "sortaballs-8-colors-current-puzzle-id",
})